import { useState, useEffect, useContext } from 'react';
import { SiteContext } from '../components/global/site-context';

const STORAGE_KEY = "crAccount";
const STORAGE_TIMESTAMP = "crAccountTimestamp";
const TIME_WINDOW = 1000 * 60 * 60 * 24 * 7; // one week
const USER_API = "https://api.commonroom.io/auth/user-check";

const tryFetch = async ({ url, method = "GET" }) => {
  try {
    const res = await fetch(url, {
      method,
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      }
    });
    if (!res.ok) {
      // console.debug("FETCH ERROR", res.status);
      return;
    } else {
      // console.log("FETCH SUCCESS", res);
    }
    return res.json();
  } catch (e) {
    console.debug("FETCH ERROR CATCH", e);
    return [];
  }
};

const useAccountCR = () => {
  const [account, setAccount] = useState(null);
  const site = useContext(SiteContext);
  const storage = site.metrics.analytics.storage;

  const storedUser = storage.getItem(STORAGE_KEY);
  const storedTimestamp = storage.getItem(STORAGE_TIMESTAMP);
  const currentTime = Date.now();
  const isExpired = storedTimestamp && (currentTime - parseInt(storedTimestamp)) > TIME_WINDOW;
  const isValidUser = storedUser && storedUser !== "null" && !isExpired;

  useEffect(() => {
    if (isValidUser) {
      try {
        const parsedUser = JSON.parse(storedUser);
        setAccount(parsedUser);
        console.debug("User loaded from cache", parsedUser);
      } catch (e) {
        console.error("Error parsing user from cache", e);
        storage.removeItem(STORAGE_KEY);
      }
    } else {
      tryFetch({
        url: USER_API,
      }).then((data) => {
        if (data?.identityId) {
          setAccount(data);
          storage.setItem(STORAGE_KEY, JSON.stringify(data));
          storage.setItem(STORAGE_TIMESTAMP, Date.now());
          setAccount(data);
          console.debug("User loaded", data);
        } else {
          console.debug("No user found");
          storage.removeItem(STORAGE_KEY);
          setAccount(null);
        }
      });
    }
  }, []);

  return account;
};

export default useAccountCR;
